var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArch3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 365,
    height: 365,
    viewBox: "0 0 365 365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-7 {\n        fill: none;\n      }\n\n      .cls-2 {\n        clip-path: url(#clip-Custom_Size_1);\n      }\n\n      .cls-3 {\n        fill: #1e505f;\n      }\n\n      .cls-4 {\n        clip-path: url(#clip-path);\n      }\n\n      .cls-5, .cls-6 {\n        fill: #5ce5bb;\n      }\n\n      .cls-5, .cls-7 {\n        stroke: #221f1f;\n      }\n\n      .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-5 {\n        stroke-width: 2px;\n      }\n\n      .cls-6 {\n        stroke: #f2ea4c;\n      }\n\n      .cls-6, .cls-7 {\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    className: "cls-1",
    width: 358.74,
    height: 236.75,
    transform: "matrix(0.738, -0.674, 0.674, 0.738, -75.077, 171.136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Custom_Size_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 365,
    height: 365
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Custom_Size_1",
    "data-name": "Custom Size \\u2013 1",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arch-3",
    transform: "translate(56.077 5.809)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    className: "cls-3",
    d: "M217.2,289.87a82.179,82.179,0,1,1,83.071-141.821l49.9-85.169C264,12.29,153.08,41.12,102.56,127.32S81.09,324.45,167.3,375Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    className: "cls-5",
    d: "M215.62,274.3a82.178,82.178,0,1,1,83.062-141.823l49.9-85.167C262.37-3.28,151.5,25.55,101,111.75S79.51,308.88,165.72,359.47Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    className: "cls-5",
    d: "M216.05,273.87a82.179,82.179,0,1,1,83.071-141.821L349,46.88C262.81-3.71,151.93,25.12,101.41,111.32S79.94,308.45,166.16,359Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    className: "cls-6",
    d: "M180.11,334l.88-1.54a21.5,21.5,0,0,0-4.17-6.38c-4.85-5.31-9.17-6.22-13.4-7.14s-8.17-1.72-12.7-6.67-5-9-5.5-13.25-1.05-8.69-5.9-14-9.17-6.23-13.4-7.14-8.17-1.72-12.7-6.68-5-9-5.49-13.25-1.06-8.68-5.9-14-9.17-6.22-13.4-7.14c-2.62-.55-5.72-1-8.29-2.55.07.57.24,1.16.36,1.69a35,35,0,0,0,7.68,2.2c4.18.86,8.17,1.71,12.7,6.67s5,9,5.5,13.25,1.05,8.68,5.89,14,9.18,6.23,13.4,7.14,8.18,1.72,12.7,6.67,5,9,5.5,13.26,1,8.68,5.9,14,9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68a20,20,0,0,1,4.24,7.04Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    className: "cls-6",
    d: "M336.13,48.29c.46,3.71.91,7.62,4.21,12l.78-1.26c-2.8-4-3.22-7.34-3.64-10.91a25.311,25.311,0,0,0-1.76-7.76c-.66-.32-1.27-.58-1.93-.9C335.48,42.55,335.78,45.39,336.13,48.29Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    className: "cls-6",
    d: "M275.73,28.24c.53,4.3,1,8.69,5.9,14s9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68,5,9,5.5,13.25,1,8.68,5.9,14a22.19,22.19,0,0,0,5.37,4.37l.67-1.17a21.3,21.3,0,0,1-5-4.12c-4.53-5-5-9-5.5-13.25s-1.05-8.68-5.9-14-9.17-6.22-13.4-7.13-8.17-1.72-12.7-6.68-5-9-5.5-13.25a28.411,28.411,0,0,0-.63-4.37,6.89,6.89,0,0,1-1.43-.16C275.42,25.33,275.47,26.55,275.73,28.24Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    className: "cls-6",
    d: "M122.22,320c-.53-4.29-1-8.68-5.9-14A26.66,26.66,0,0,0,105,299.2a20.048,20.048,0,0,0,1.5,2,25.44,25.44,0,0,1,8.78,5.65c3.88,4.25,5.26,9.73,5.72,13.35.55.6.45.9,1,1.5C122.14,321.75,122.22,320.07,122.22,320Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    className: "cls-6",
    d: "M153.82,347c-3.71-4-8.82-6.8-12.82-6.8,1.07.86,1.44,1.63,2.5,2.5,1.93.9,7,2.79,9.13,5.05,1.26.87,3.07,4,4.37,4.95C156.28,351.61,154.87,348.19,153.82,347Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    className: "cls-6",
    d: "M211.58,50.29c4.18.86,8.17,1.72,12.7,6.67s5,9,5.5,13.26,1.05,8.68,5.9,14,9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68,5,9,5.5,13.25c.38,3.13.32,6,2.46,9.57.62.07,2.12.86,1.76.32-2.52-3.76-2.5-6.6-2.92-10.07-.53-4.29-1.05-8.68-5.9-14s-9.17-6.22-13.4-7.14-8.17-1.72-12.7-6.67-5-9-5.5-13.25-1.05-8.69-5.89-14-9.18-6.23-13.4-7.14-8.18-1.72-12.7-6.68c-2.88-3.15-4.15-5.38-4.75-8a7.55,7.55,0,0,0-1.27.52c.69,2.77,2,5.19,5.06,8.5C203,48.5,207.3,49.42,211.58,50.29Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    className: "cls-6",
    d: "M123.82,223.92c4.53,5,5,9,5.5,13.26s1.05,8.68,5.9,14,9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68,5,9,5.5,13.25,1.05,8.68,5.9,14,9.17,6.22,13.4,7.14c3.75.79,7.31,1.58,11.22,5.26l.73-1.21c-4.15-3.74-7.95-4.59-11.7-5.38-4.18-.87-8.18-1.72-12.7-6.68s-5-9-5.5-13.25-1-8.68-5.9-14-9.17-6.22-13.4-7.14-8.17-1.72-12.7-6.67-5-9-5.5-13.25-1-8.69-5.9-14-9.17-6.23-13.39-7.14-8.18-1.72-12.71-6.68-5-9-5.49-13.25-1.06-8.68-5.9-14a19.86,19.86,0,0,0-7.81-5.54c-.07.43-.14,1-.21,1.38a19.49,19.49,0,0,1,7,5.08c4.52,5,5,9,5.5,13.25s1,8.68,5.89,14,9.18,6.22,13.4,7.13S119.3,219,123.82,223.92Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    className: "cls-6",
    d: "M106.23,127.14c4.84,5.3,9.17,6.22,13.4,7.14s8.17,1.71,12.7,6.67,5,9,5.5,13.25,1,8.68,5.89,14,9.17,6.23,13.4,7.14,8.18,1.72,12.7,6.67,4.2,8,4.68,12.2c.19,1.21.27,2.74.5,4,.09-2.11,0-5.4.32-7.5-.56-3.53-.61-5.35-4.5-9.61-4.84-5.31-9.17-6.22-13.4-7.14s-8.17-1.72-12.7-6.67-5-9-5.5-13.25-1.05-8.69-5.89-14-9.17-6.23-13.4-7.14-8.18-1.72-12.7-6.68-5-9-5.5-13.25a2.186,2.186,0,0,0-.07-.67c-.41.65-.73,1.31-1.14,2a20.84,20.84,0,0,0,5.71,12.84Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    className: "cls-6",
    d: "M114.87,175.16c.53,4.3,1.06,8.69,5.9,14s9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68,5,9,5.5,13.25,1,8.68,5.9,14,9.17,6.22,13.4,7.14,8.17,1.71,12.7,6.67,5,9,5.5,13.25,1,8.68,5.89,14,9.18,6.23,13.4,7.14c1.05.24,2.14.43,3.18.77l.73-1.22c-1.23-.34-2.42-.63-3.66-.88-4.18-.87-8.17-1.72-12.7-6.68s-5-9-5.49-13.25-1.06-8.68-5.9-14-9.17-6.22-13.4-7.14-8.17-1.71-12.7-6.67-5-9-5.5-13.25-1.05-8.68-5.9-14-9.17-6.23-13.4-7.14-8.17-1.72-12.7-6.68-5-9-5.5-13.25-1-8.68-5.9-14-9.17-6.22-13.39-7.13c-3.76-.8-7.27-1.54-11.19-5.22a11.249,11.249,0,0,1-.44,1.42c4,3.49,7.72,4.34,11.33,5.08,4.18.86,8.17,1.72,12.7,6.67S114.39,170.92,114.87,175.16Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    className: "cls-6",
    d: "M291.53,90.13c-.53-4.3-1-8.68-5.9-14s-9.17-6.23-13.4-7.14-8.17-1.72-12.7-6.68-5-9-5.5-13.25-1.05-8.68-5.89-14S239,28.86,234.74,28a23.28,23.28,0,0,1-8.45-3l-1.89.34c3.53,2.66,6.81,3.34,10,4,4.18.87,8.17,1.72,12.7,6.68s5,9,5.5,13.25,1,8.68,5.9,14,9.17,6.22,13.4,7.14,8.17,1.72,12.7,6.67,5,9,5.5,13.25,1.05,8.69,5.89,14,9.18,6.23,13.4,7.14c.34.06.62.17.91.19l.72-1.22c-.47-.12-.9-.18-1.38-.3-4.18-.86-8.17-1.72-12.7-6.68S292,94.37,291.53,90.13Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    className: "cls-6",
    d: "M123.38,92.19c.52,4.29,1.05,8.68,5.89,14s9.17,6.22,13.4,7.14,8.18,1.71,12.7,6.67,5,9,5.5,13.25,1,8.68,5.9,14,9.17,6.23,13.4,7.14c3,.62,5.13.56,8.11,2.62.21-.38.51-.75.72-1.12-3.21-2.21-5.59-2.17-8.58-2.83-4.18-.86-8.17-1.72-12.7-6.68s-5-9-5.5-13.25-1.05-8.68-5.9-14-9.17-6.22-13.4-7.13-8.17-1.72-12.7-6.68-5-9-5.5-13.25a25.56,25.56,0,0,0-2.24-8.79,11.281,11.281,0,0,1-1,1.11,23,23,0,0,1,1.9,7.8Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    className: "cls-6",
    d: "M169.33,50.22c.53,4.29,1,8.68,5.9,14s9.17,6.22,13.4,7.14,8.17,1.72,12.7,6.67,5,9,5.49,13.25,1.06,8.69,5.9,14,9.17,6.23,13.4,7.14,8.17,1.72,12.7,6.68a18.592,18.592,0,0,1,1.78,2.39c.48-.07.92-.2,1.4-.27a15.72,15.72,0,0,0-2.18-3c-4.85-5.3-9.17-6.22-13.4-7.14s-8.17-1.71-12.7-6.67-5-9-5.5-13.25-1.05-8.68-5.89-14-9.18-6.23-13.4-7.14-8.18-1.72-12.7-6.67-5-9-5.5-13.26A36.59,36.59,0,0,0,170,45.2c-.44.22-.79.44-1.23.66C169,47.36,169.11,48.67,169.33,50.22Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    className: "cls-6",
    d: "M146.38,71.18c.53,4.29,1.05,8.68,5.9,14s9.17,6.23,13.39,7.14S173.85,94,178.37,99s5,9,5.5,13.25,1,8.69,5.9,14,9.17,6.23,13.4,7.14a22.5,22.5,0,0,1,6,1.87c.39-.27,1.34-1,1.34-1-2.76-1.52-4.51-1.67-7.08-2.17-4.18-.86-8.17-1.72-12.7-6.67s-5-9-5.5-13.26-1.05-8.68-5.9-14-9.17-6.23-13.39-7.14-8.18-1.72-12.7-6.68-5-9-5.5-13.25a24.34,24.34,0,0,0-2.56-9.42c-.35.32-.69.54-1,.86a24.07,24.07,0,0,1,2.2,8.65Z",
    transform: "translate(-75.08 -20.45)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    className: "cls-7",
    d: "M216.05,273.87a82.179,82.179,0,1,1,83.071-141.821L349,46.88C262.81-3.71,151.93,25.12,101.41,111.32S79.94,308.45,166.16,359Z",
    transform: "translate(-75.08 -20.45)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArch3);
export default __webpack_public_path__ + "static/media/arch-3.5e030048641dc7770f47a79398a145f6.svg";
export { ForwardRef as ReactComponent };